import 'polyfills/browser';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import HomePage from 'components/Landing/HomePage/HomePage';

import { registerComponents } from '../src/registrations';

registerComponents({ HomePage });
